import { createListable } from 'listable'
import { REPORTS_PATH } from 'features/report/types'
import options from './config'
import { combineEpics } from 'redux-observable'
import { createEffects } from './effects'
import customReducer from './reducer'

const listableModule = createListable({
  name: 'reportExceptions',
  config: options,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions
const customEpic = createEffects(listableModule.actions)
const defaultEpic = listableModule.effects
export const effects = defaultEpic
  ? combineEpics(customEpic, defaultEpic)
  : customEpic
export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `${REPORTS_PATH}/fuel-exceptions`,
}
